import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ServiceRespone } from 'src/app/model/serviceResponse';
import { AppConstants } from 'src/environments/constants';
import { msConfig } from '../ms-config';
import { INotificheService } from './INotidicheService';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { TipologiaNotifica } from 'src/app/pages/notifiche/model/Notifica';
import { CommonUtils } from 'src/utils/CommonUtils';


@Injectable({
  providedIn: 'root'
})
export class NotificheService implements INotificheService {
  private _numberNotifications: Subject<number> = new Subject<number>();
  private _reset: Subject<boolean> = new Subject<boolean>();

  constructor(private http: HttpClient) { }

  setNumberNotification(numeroNotifiche: number) {
    this._numberNotifications.next(numeroNotifiche);
  }

  getNumberNotification(): Observable<number> {
    return this._numberNotifications.asObservable();;
  }

  setResetTimer(value: boolean) {
    this._reset.next(value);
  }

  getGetResetTimer(): Observable<boolean> {
    return this._reset.asObservable();;
  }

  getNotifiche(isNonLette: boolean, first?: number, length?: number, dataInizio?: Date, dataFine?: Date, tipologiaNotifica?: TipologiaNotifica[]): Observable<ServiceRespone> {
    let url = msConfig['ms-notifiche'] + AppConstants.PATH_NOTIFICHE;
    let params: any = {};
    params.isNonLette = isNonLette;
    params = CommonUtils.containsParam(params, first, "first")
    params = CommonUtils.containsParam(params, length, "length")
    params = CommonUtils.containsParam(params, tipologiaNotifica, "tipologieNotificaList")


    if (dataInizio != null) {
      params = CommonUtils.containsParam(params, CommonUtils.formatDate(dataInizio), "dataInizio")
    }
    if (dataFine != null) {
      params = CommonUtils.containsParam(params, CommonUtils.formatDate(dataFine), "dataFine")
    }

    return this.http
      .get(url, { params })
      .pipe(map((resp: ServiceRespone) => {
        let ordine;
        ordine = resp;
        return ordine;
      }))
  }

  getTotaleNotifiche(dataInizio?: Date, dataFine?: Date, tipologiaNotifica?: TipologiaNotifica[]): Observable<ServiceRespone> {
    let url = msConfig['ms-notifiche'] + AppConstants.PATH_COUNT_NOTIFICHE;
    let params: any = {};

    params = CommonUtils.containsParam(params, tipologiaNotifica, "tipologieNotificaList")

    if (dataInizio != null) {
      params = CommonUtils.containsParam(params, CommonUtils.formatDate(dataInizio), "dataInizio")
    }
    if (dataFine != null) {
      params = CommonUtils.containsParam(params, CommonUtils.formatDate(dataFine), "dataFine")
    }
    return this.http
      .get(url, { params })
      .pipe(map((resp: ServiceRespone) => {
        let ordine;
        ordine = resp;
        return ordine;
      }))
  }


}

